// ⚠️ AUTO-GENERATED — DO NOT EDIT MANUALLY
// Source: ./svg/IconAccount.svg — regenerate with `nx run creditflowresearch-uilib:icons-generate --write`
import BaseIcon from './BaseIcon';
import type { IIconProps } from './types';

const IconAccount = (props: IIconProps) => (
  <BaseIcon viewBox="0 0 16 16" fill="currentColor" { ...props }>
    <path d="M12.4444 7.11111V0H3.55556V3.55556H0V16H7.11111V12.4444H8.88889V16H16V7.11111H12.4444ZM3.55556 14.2222H1.77778V12.4444H3.55556V14.2222ZM3.55556 10.6667H1.77778V8.88889H3.55556V10.6667ZM3.55556 7.11111H1.77778V5.33333H3.55556V7.11111ZM7.11111 10.6667H5.33333V8.88889H7.11111V10.6667ZM7.11111 7.11111H5.33333V5.33333H7.11111V7.11111ZM7.11111 3.55556H5.33333V1.77778H7.11111V3.55556ZM10.6667 10.6667H8.88889V8.88889H10.6667V10.6667ZM10.6667 7.11111H8.88889V5.33333H10.6667V7.11111ZM10.6667 3.55556H8.88889V1.77778H10.6667V3.55556ZM14.2222 14.2222H12.4444V12.4444H14.2222V14.2222ZM14.2222 10.6667H12.4444V8.88889H14.2222V10.6667Z" />
  </BaseIcon>
);

export default IconAccount;
